import { createGlobalStyle } from 'styled-components';
import media from 'styled-media-query';
import { generateMedia } from 'styled-media-query';

const customMedia = generateMedia({
  mobile: "425px",
  tablet: "768px",
  laptop: "1024px",
  laptopL: "1440px",
  laptopXL: "2560px"
})

const GlobalStyles = createGlobalStyle`
  /* http://meyerweb.com/eric/tools/css/reset/
   v2.0 | 20110126
   License: none (public domain)
  */


  



  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }
  html {
    font-size: 62.5%;
    scroll-behavior: smooth;
  }
  body {
    line-height: 1;
  }
  ol, ul {
    list-style: none;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  * {
    box-sizing: border-box;
  }
  body {
    background: var(--bg-light);
    font-weight: 400;
    font-family: sans-serif; /*"Open Sans", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"; */

    font-size: 1.5rem;
    line-height: 160%;
    ${media.greaterThan('large')`
      font-size: 1.7rem;
    `}
  }
  img {
    display: block;
  	max-width: 100%;
  	height: auto;
    width: inherit;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  

  .hero {
    width: 100%;
    height: 100%;
    position: absolute !important;
    z-index: -2;
  }

  .header {
    ${'' /* background-color: rgba(70, 70, 73, 0.95); */}

    img {
      max-width: 90%;
    }
  }

  .header-page {
    ${'' /* background-color: rgba(100, 103, 112, 0.99); */}
  }

  /* Logo and animation */
  .logo-container {
    position: relative;
    overflow: hidden;
    width: 5rem;
    margin-bottom: 3vh;
    animation: reveal2 600ms linear forwards 900ms;
  }

  .text-container {
    height: 5rem;
    position: relative;
    overflow: hidden;
    width: 0;
    animation: reveal2 800ms linear forwards 900ms;
  }

  .logo__text {
    max-width: none;
    width: 18rem;
    position: absolute;
    top: 10%;
  }

  .logo__icon {
    width: 5rem;
    position: absolute;
    right: 0;
    top: 0;
    animation: rotate 1300ms 3 linear 300ms,
               shrink 400ms ease forwards 1500ms;
  }

  @keyframes shrink {
    100% {
      width: 2.5rem;
    }
  }  

  @keyframes rotate {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg);
  }
}
  
  @keyframes reveal2 {
    100% {
      width: 21rem;
    }
  }


 /* dutch food processing... */
  .logo-text {
    line-height: 1;
    font-size: 110%;
    margin-top: 2rem;
    font-weight: 300;
    text-shadow: 2px 2px 3px rgba(255,255,255,0.1);

    ${media.lessThan('small')`
      display: none;
    `}
  } 

  .light {
    color: var(--body-bg);
  }


  .homepage {
    background-color: var(--gray-extra-light);

    h1 {
      overflow-wrap: break-word;
    }
  }

  .homepage-1 {
    display: flex;
    justify-content: center;
    height: 100vh;
    background: transparent;
    padding: 6vw;

    .container__subtitle {
      width: 90%;
      position: relative;
      

      ${customMedia.greaterThan('tablet')`
        margin-bottom: 8vh;        
      `}
    }

    .grid-container {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 8vh;

      ${customMedia.greaterThan('tablet')`

        display: grid;
        grid-template-columns: repeat(3, 1fr);
        ${'' /* width: 23rem; */}
        width: 372px;
      `}

      @media (min-width: 1170px) {
        width: 396px;
      }

      ${customMedia.greaterThan('laptopL')`
        width: 480px;        
      `}

      ${customMedia.greaterThan('laptopXL')`
        width: 744px;
      `}
    }
    
    .subtitle {
      color: rgba(255, 255, 255, 0.7);
      font-size: 100%;      
      letter-spacing: 2px;      
      margin-right: 1rem;

      &:last-child {
        margin-right: 0;
      }
      
      ${customMedia.greaterThan('tablet')`
        font-weight: 100;
        white-space: nowrap;
        font-size: 95%;
        margin-right: 0;
      `}

      ${customMedia.greaterThan('laptopL')`
        font-size: 120%;
      `}
      
      ${customMedia.greaterThan('laptopXL')`
        font-size: 200%;
      `}
    }
    
  }

  .taglineBlock {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-top: 10vh;
    margin-left: 2vh;

    ${media.greaterThan('medium')`
      margin-top: 9vh;
      margin-left: 5vh;
    `}

    ${customMedia.between('tablet', 'laptop')`
      width: 425px; 
      ${'' /* width: 26.56rem; */}
    `}

    ${customMedia.greaterThan('laptop')`      
      width: 80%;
    `}

    ${customMedia.greaterThan('laptopL')`      
      width: 60%;
    `}

    .container__title {
      position: relative;
      overflow: hidden;
    }

    h1 {
      color: var(--gray-extra-light);
      letter-spacing: 1px;
      margin-bottom: 5vh; /*10vh */
      word-break: break-word;
      position: relative;

      ${customMedia.greaterThan('tablet')`      
        margin-bottom: 4vh;
      `}
    }

    button {
      transform: translateY(60vh);
      animation: up 1000ms ease forwards 2000ms;
      
      ${customMedia.greaterThan('tablet')`      
        ${'' /* animation: up 1000ms ease forwards 10000ms; */}
        transform: translateY(0);
      `}
    }

    @keyframes up {
      100% {
        transform: translateY(0);
      }
    }

  }

  .homepage-2 {
    
    height: auto;    
    color: var(--text-color);
    padding: 0 5vw 10rem;
    text-align: center;

    h1 {
      margin-bottom: 5rem;
      padding-top: 10rem;
      font-size: 150%;
    }

    p {
      color: var(--gray-light);
      font-size: 110%;
      line-height: 2;
    }

    ${media.greaterThan('large')`
      padding: 0 10rem 15rem;
    `}

    ${customMedia.greaterThan('laptop')`
      
      h1 {
        font-size: 300%;
      }
    `}

    ${customMedia.greaterThan('laptopL')`
      h1 {
        width: 100rem;
        margin: auto;
        margin-bottom: 5rem;
        letter-spacing: 1px;
      }
      p {
        width: 80rem;
        margin: auto;
      }
    `}

    ${customMedia.greaterThan('laptopXL')`
      padding: 0 20vw 15rem;
    `}


    
  }

  .homepage-3 {
    padding: 5rem 0;
  }

  .homepage-4 {
    padding: 5vh 3rem;
    background-color: white;
    position: relative;

    h1 {
      text-transform: uppercase;
      text-align: center;
      margin-bottom: 4rem;
      margin-top: 6rem;
      color: var(--text-color);
    }

    .usp {      

        h2 {
            font-weight: bold;
          }

        p {
        color: var(--text-light);
        }       

        svg {
          margin-right: 3rem;
          margin-bottom: .5rem;
          border-radius: 100%;
          background-color: var(--primary-color);
          padding:5px;

          ${media.lessThan('medium')`
            height: 30px;
            width: 30px;
          `}
          
        }

        .usp-item {          
          margin-top: 3rem;
          margin-right: .5rem;

          &:last-child {
            margin-bottom: 3rem;
          }
          
          ${media.greaterThan('small')`
            display: flex;
            ${'' /* align-items: flex-start; */}

            .usp-copy {
              flex: 1;
            }
          `}
        }


    }

    

    

    ${customMedia.greaterThan('laptop')`
      display: flex;
      align-items: stretch;
      justify-content: center;
      padding: 5rem 8rem;

      .titel {
        display: flex;
        align-items: center;
        margin-right: 1.5rem;
        ${'' /* border-right: 4px solid var(--primary-color); */}
      }

      h1 {
        flex: 1;
        text-align: right;
        margin-right: 5rem;
        font-size: 350%;        
      }

      .usp {
        flex: 0 0 55%;
        ${'' /* padding-left: 1rem;  */}
      }

      .usp-copy {
        margin-left: 1rem;
      }
    `}

    ${customMedia.greaterThan('laptopXL')`
      h1 {
        font-size: 450%;
      }
    `}

    ${customMedia.greaterThan('laptopXL')`
      .usp {
        flex: 0 0 40%;
      }
    `}
    
  }

  /* Yellow corners */
  .frame {
      display: inline-block;
      height: 30px;
      width: 30px;
      position: absolute;
    }

    .top {
      top: 5vh;
      border-top: var(--border);
    }

    .right {
      right: 3rem;
      border-right: var(--border);
    }

    .left {
      left: 3rem;
      border-left: var(--border);
    }

    .bottom {
      bottom: 5vh;
      border-bottom: var(--border);
    }

  .homepage-5 {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 5vh 3rem 3rem;
    color: var(--text-color);

    ${media.greaterThan('large')`
      padding: 5vh 10rem 3rem;
    `}

    h1 {
      text-transform: uppercase;
      margin-bottom: 3rem;
      font-size: 200%;
      margin-bottom: 4rem;
      margin-top: 6rem;
    }

    h2 {
      font-weight: bold;
      margin-bottom: 2rem;
    }

    h3 {
      font-size: 120%;
      font-weight: 600;
    }

    p {
      margin-bottom: 2rem;
      color: var(--gray-light);
      font-size: 110%;
      line-height: 2;
    }


    & > p {

      ${customMedia.greaterThan('laptopL')`
        width: 80rem;
      `}

      ${customMedia.greaterThan('laptopXL')`
        max-width: 60%;
      `}
    }

    .people {
      ${media.greaterThan('large')`
        display: flex;
        margin-bottom: 10rem;
    `}
    }

    .person {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 2rem;

      ${customMedia.greaterThan('laptop')`
        padding: 2rem 5rem;
      `}
    }

    .person-info {
      padding: 1.5rem;
    }

    .person-img {
      ${'' /* background-color: var(--gray-light); */}
      width: 200px;
      height: 200px;
      border-radius: 100%;
    }

    
  }


  footer {
    
  }

  /* Page Tag */
  .page-tag {

    img {
      width: 8rem;
    }

    ${customMedia.greaterThan('laptopXL')`
        img {
          width: 10rem;
        }
    `}
  }

  /* About Us */

  .about {

    .team-person {
      background-color: rgba(137, 139, 143, 0.9);
      margin: 2rem 0;
      padding: 1rem 2rem;
      color: white;
      

      h3 {
        font-size: 120%;
        text-transform: uppercase;
        letter-spacing: 1px;
        text-decoration: underline;
        padding: 2rem 0;
      }

      p {
        font-size: 100%;
        line-height: 2;
        letter-spacing: 0.3px;
        margin-bottom: 3rem;
      }

      p:first-child {
        max-width: 200px;
        margin-left: auto;
        margin-right: auto;
      }
    }

    ${customMedia.greaterThan('laptop')`
      max-width: 90%;

      .team-person {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        padding: 3rem;
        padding-right: 6rem;

        p {
          margin-top: 3rem;
          ${'' /* margin-right: 3rem; */}
          margin-bottom: 0;
          text-align: justify;
          word-break: break-word;
        }

        p:first-child {
          flex: 1;
          margin: 0;
        }

        h3 {
          flex: 1;
          font-size: 150%;
          line-height: 1.5;
          text-align: right;
          margin-left: 2rem;
        }
      }

      
    `}

    ${customMedia.greaterThan('laptopL')`
      max-width: 80%;


      .team-person {
        padding-right: 10rem;

        p {
          font-size: 110%;
          letter-spacing: .5px;
        }
      }
    `}
  }

  /* Contact */

  .contact {
    .contact-person {
      background-color: white;
      padding: 6vh 4rem;
      position: relative;
      margin-bottom: 2rem;
      box-shadow: 0 10px 8px -8px rgba(0, 0, 0, 0.3);

      p:last-child {
        max-width: 80%;
        margin: 3rem auto 1rem;
      }
    }

    a > img {
      height: 28px;
    }

    .person-info {
      color: var(--gray);
      font-size: 100%;
      text-align: center;
    }

    li {
      margin-bottom: 1rem;

      p {
        width: 40px;
        padding: 4px;
        margin: auto;
        border: 2px solid var(--gray);
        border-radius: 5px;
      }
    }

    li:first-child {
      font-weight: 600;    
      font-size: 190%;
      margin: 0 auto 2rem;
      line-height: 1.3;
      width: fit-content;
      padding-bottom: .5rem;
      border-bottom: 4px solid var(--primary-color);
    }

    li:nth-child(2) {
      color: var(--gray-light);
      font-size: 70%;
      text-transform: uppercase;
      letter-spacing: 2px;    
      margin-bottom: 3rem;
    }

    li:nth-child(5) {
      margin-bottom: 0;

      &:hover {
        cursor: pointer;
        

        p {
          border-color: var(--primary-color);
          background-color: var(--primary-color);
          border-radius: 100%;
          transition: all 50ms ease-in-out;
          

        }
      }
    }
    
    ${customMedia.greaterThan('tablet')`
      max-width: 90%;

      .contact-person {

        p:last-child {
          max-width: 50%;
        }
      }
    `}

    ${customMedia.greaterThan('laptop')`
      .contact-person {
        display: flex;
        align-items: flex-end;

        p:last-child {
          max-width: 30%;
          margin: 0;
          flex: 1;
        }
      }

      .person-info {
        flex: 1;
        text-align: left;
      }

      li:first-child {
        margin: 0 0 1.5rem;
      }

      li:last-child {
        margin: 0;
      }      
    `}

    ${customMedia.greaterThan('laptopL')`
      max-width: 80%;
    `}  

    ${customMedia.greaterThan('laptopXL')`
      
        
        li:first-child {
          font-size: 290%;
        }

        li:nth-child(2) {
          font-size: 90%;
          letter-spacing: 5px;
          margin-bottom: 7rem;
        }

        li {
          font-size: 140%;
          margin-bottom: 3rem;
          letter-spacing: 1px;    

          p {
            width: 60px;
          }
        }
      
        a > img {
          height: 48px;
        }
      
    `}    
  }

  /* Our clients */

  .clients-wrapper {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 3rem;
    padding: 3rem;
    justify-content: space-around;
    background-color: white;

    p {
      flex: 0 1 200px;
      margin-bottom: 5rem;
    }
  }





/* Button Color styles */

  .btn--primary--solid {
    background-color: var(--primary-color);
    color: black;
    border: none;
  }

  .btn--danger--solid {
    background-color: var(--danger);
    color: var(--dark);
    border: none;
  }

  .btn--success--solid {
    background-color: var(--success);
    color: var(--dark);
    border: none;
  }

  .btn--white--solid {
    background-color: var(--white);
    color: var(--dark);
    border: none;
  }

  .btn--dark--solid {
    background-color: var(--dark);
    color: var(--white);
    border: none;
  }

  .btn--primary--outline {
    background-color: transparent;
    color: var(--primary-color);
    border: 2px solid var(--primary-color);
  }

  .btn--danger--outline {
    background-color: transparent;
    color: var(--danger);
    border: 2px solid var(--danger);
  }

  .btn--success--outline {
    background-color: transparent;
    color: var(--success);
    border: 2px solid var(--success);
  }

  .btn--white--outline {
    background-color: transparent;
    color: var(--white);
    border: 2px solid var(--white);
  }

  .btn--dark--outline {
    background-color: transparent;
    color: var(--dark);
    border: 2px solid var(--dark);
  }

  /* Button Size styles */

  .btn--medium {
    padding: 10px 20px;
    font-size: 18px;
  }

  .btn--large {
    padding: 15px 30px;
    font-size: 20px;
  }


  :root {
    --gray-extra-light: #eaeaea; /* rgba(234, 234, 234, 0.9) */
    --gray-light: #898B8F; /* rgba(137, 139, 143, 0.5) */
    --gray: #475060;
    --gray-dark: #464649; /* rgba(70,70,73,0.8)*/

    --primary-color: #FFDB00; /* yellow */
    --secondary-color: var(--gray-light);
    --thirdy-color: #001ff9;


    --danger: #eb3f27;
    --success: #75fa83;
    --white: #fdfdfd;
    --dark: #181717;

    --bg-body: var(--gray-light);
    --body-bg: #FFFFFF;

    --bg-light: var(--gray-extra-light);
    --bg-dark: var(--gray-dark);
    --bg-mid-dark: var(--gray-light);

    --border-light: var(--gray-light);
    --border-dark: var(--gray-dark);
    --border: 3px solid var(--primary-color);

    --link-color: var(--primary-color);
    --link-color-hover: var(--thirdy-color);

    --text-color: #4a4a4a;
    --text-light:var(--gray-light);
    --text-dark: var(--gray-dark);
    --text-white: var(--body-bg);

    --width-container: 1040px;

    --space: 2rem;
    --space-sm: 1rem;
    --space-lg: 3rem;

    --font-menu: "Muli", sans-serif;

  }
`;
export default GlobalStyles;
